import { PublicClientApplication } from "@azure/msal-browser";

const requiredEnv = (key: string): string => {
  const value = process.env[key];
  if (!value) {
    throw new Error(`Missing required environment variable: ${key}`);
  }
  return value;
};

const clientId = requiredEnv("REACT_APP_AAD_CLIENT_ID");
const tenantId = requiredEnv("REACT_APP_AAD_TENANT_ID");
const redirectUri = requiredEnv("REACT_APP_AAD_REDIRECT_URI");

const msalConfig = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri,
  },
  cache: {
    cacheLocation: "sessionStorage", // או "localStorage"
    storeAuthStateInCookie: true, // שימוש בעוגיות לאימות
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);